module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/7d4a772f3373b68f96bc881c6e3db256.svg";